import { Box, BoxProps, Stack } from "@chakra-ui/react";
import * as React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { TabName } from "../../utils/typings";

import { Header } from "../Header";
import { Show } from "../Show";

interface Props extends BoxProps {
  title: string;
  children: React.ReactNode;
  currentTab?: TabName;
  showHeader?: boolean;
  showFooter?: boolean;
}

export const Page = ({
  title,
  showHeader = true,
  showFooter = true,
  currentTab,
  children,
  ...rest
}: Props) => {
  const [tabIndex, setTabIndex] = React.useState<number>(0);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title} | Almond</title>
      </Helmet>
      <Stack
        direction="column"
        align={{ base: "flex-start", md: "center" }}
        w="full"
        h="full"
      >
        <Show condition={showHeader}>
          <Header
            onTabChange={(tab: number) => setTabIndex(tab)}
            currentTab={tabIndex}
          />
        </Show>
        <Box
          direction="column"
          w="full"
          h="full"
          p={{ base: "0px", md: "30px", lg: "12px" }}
          {...rest}
        >
          {children}
        </Box>
      </Stack>
    </HelmetProvider>
  );
};
